import { parseStringValue } from "../parse-string-value.js";
/**
 * The canonical list of rules applied to passwords. Order matters: the
 * validator returns the first failing rule's message, and the UI renders
 * them in this order. Exported so the frontend can build a live checklist
 * without duplicating the rules.
 */
export const PASSWORD_RULES = [
    {
        label: "Mínimo 8 caracteres",
        message: "La contraseña debe tener al menos 8 caracteres",
        test: (s) => s.length >= 8,
    },
    {
        label: "Una letra mayúscula",
        message: "Debe incluir al menos una letra mayúscula",
        test: (s) => /[A-Z]/.test(s),
    },
    {
        label: "Una letra minúscula",
        message: "Debe incluir al menos una letra minúscula",
        test: (s) => /[a-z]/.test(s),
    },
    {
        label: "Un número",
        message: "Debe incluir al menos un número",
        test: (s) => /[0-9]/.test(s),
    },
    {
        label: "Un carácter especial",
        message: "Debe incluir al menos un carácter especial",
        test: (s) => /[^A-Za-z0-9]/.test(s),
    },
];
export function passwordField(opts) {
    return (value) => {
        const res = parseStringValue(value, opts);
        if (!res.isValid || !res.value)
            return res;
        for (const rule of PASSWORD_RULES) {
            if (!rule.test(res.value)) {
                return { isValid: false, error: rule.message };
            }
        }
        return {
            isValid: true,
            value: res.value,
        };
    };
}
